/**
 * @generated SignedSource<<946a0335f019b2ea4fd66efc9cbdf8e0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftItemTileContent_nftAuction$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CollectorTileContent_nftAuction" | "CreatorContent_nftAuction" | "RegularTileContent_nftAuction">;
  readonly " $fragmentType": "NftItemTileContent_nftAuction";
};
export type NftItemTileContent_nftAuction$key = {
  readonly " $data"?: NftItemTileContent_nftAuction$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftItemTileContent_nftAuction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftItemTileContent_nftAuction",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RegularTileContent_nftAuction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CreatorContent_nftAuction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CollectorTileContent_nftAuction"
    }
  ],
  "type": "NftAuction",
  "abstractKey": null
};

(node as any).hash = "b7abf7ba492a5d6f92cf0cff1fdf9d60";

export default node;
